import "./EmailVerificationPage.css";
import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from 'react-router-dom';


export default function EmailVerificationPage() {

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const success = searchParams.get('success');

    useEffect(() => {
        if (success !== 'true') {
            navigate('/');
        }
    }, [success, navigate]);

    if (success !== 'true') return null;

    return (
        <div className="email-verification-container">
            <div className="email-verification-content">
                <div className="email-verification-icon">✓</div>
                <h1>Email Verified</h1>
                <p>Thanks for verifying your email address.</p>
                <p className="email-verification-note">
                    Before you can log in, an administrator from your organization
                    still needs to approve your access. You'll receive a confirmation
                    email from <strong>AskSmart</strong> once you've been approved —
                    please check your spam folder if you don't see it.
                </p>
                <button
                    type="button"
                    className="registrationLoginBtn"
                    onClick={() => {
                        window.location.href = `${process.env.REACT_APP_BACKEND_URL}/clear-and-login`;
                    }}
                >
                    Go to Log In
                </button>
            </div>
        </div>
    );
}
